import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { enabledToolKeys, PARTNER_TOOLS } from "@/lib/partnerTools";

// Blocca l'accesso via URL a uno strumento non attivato dall'Admin per il Partner.
export function ToolGuard({ tool, children }) {
  const { user } = useAuth();
  if (enabledToolKeys(user).includes(tool)) return children;
  const label = PARTNER_TOOLS.find((t) => t.key === tool)?.label || "Questa funzione";
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center py-20 text-center" data-testid="tool-not-enabled">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-terracotta/10"><Lock className="h-7 w-7 text-terracotta" /></div>
      <h2 className="mt-5 font-heading text-2xl font-semibold text-forest">Funzione non attiva per il tuo profilo</h2>
      <p className="mt-2 text-sm text-muted-foreground">«{label}» viene attivata da Assietica in base al tuo profilo. Contatta l'Agenzia per richiederla.</p>
      <Link to="/" className="mt-6"><Button variant="outline" data-testid="tool-guard-home">Torna alla Home</Button></Link>
    </div>
  );
}
